import React, { useState, useEffect } from "react";
import {
  Radio,
  Typography,
  Form,
  Row,
  Divider,
  Select,
  Input,
  Button,
  DatePicker,
  Modal,
  Descriptions,
  notification,
  Checkbox,
  List,
  Tooltip,
  Space,
  Col,
} from "antd";
import { useSelector, useDispatch } from "react-redux";
import {
  getFields,
  getCoverPlans,
  saveStep,
  updateStep,
  clearSteps,
  checkQoute,
  disableQoute,
  setDentalCare,
  setOutPatientCare,
  setOpticalCare,
} from "../../../store/policy";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import styles from "./index.module.css";
import peopleWorking from "../../../utils/img/peopleWorking.png";
import checkFilled from "../../../utils/img/checkFilled.png";
import {
  ArrowLeft,
  Calculator,
  FileText,
  HelpCircle,
  Loader2,
  Stethoscope,
  User,
  Eye,
  Check,
  ExternalLink,
  Pencil,
  Sparkles,
} from "lucide-react";
import { validationRules } from "../../common/Utils";
import viewCover from '../../../utils/pdf/viewPolicy.pdf';
import providerList from '../../../utils/pdf/KenyaServiceProviderList .xlsx';

const { Title, Text, Paragraph } = Typography;

const tooltipContent = {
  copay:
    "A copay is a percentage of the total cost of a medical service for outpatient, dental and optical services. For example, if you select a copay is 20% and the service costs 1000, you would pay 200, while your insurance covers the remaining 800. This percentage is applied each time you receive service.",
  coverType: `Shared Limit: Select this option if you want a single coverage limit for your entire family. The total limit is shared among all members, so if added, Outpatient, Dental and Optical expenses for any member count toward the same limit. Non-Shared Limit: Choose this option to assign individual coverage limits to each person on the plan. Each member has their own separate limit for Outpatient, Dental and Optical, ensuring that one person's expenses don't impact the coverage available to others.`,
  serviceProviderCategory:
    "You can choose a list of service providers to get treatment from depending on how much you want to pay. You can only go to a service providers on the category you select.",
  coverBenefits: `The prices displayed are estimates based on the information you've provided.
To calculate your final premium, we'll ask about the health and medical history
of applicants in the next step to finalize your premium. Click "Apply Now" after
selecting your desired plan`,
};

function EnhancedStep3({ setCurrent, current }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [selectedBenefit, setSelectedBenefit] = useState([]);
  const [form1] = Form.useForm();
  const [sortedFields, setSortedFields] = useState([]);
  const [coverPlans, setCoverPlans] = useState([]);
  const existingValues = sessionStorage.getItem("values");
  const existingSelectedPlan = localStorage.getItem("selectedPlan");
  const [api, context] = notification.useNotification();
  const coverageCountry = localStorage.getItem("coverageCountry")
    ? localStorage.getItem("coverageCountry")
    : "";

  const {
    form,
    steps,
    fields,
    loading,
    plans,
    getQoute,
    outPatientCare,
    dentalCare,
    opticalCare,
    coverPlansLoading,
  } = useSelector((state) => state.policySlice);

  useEffect(()=>{
    console.log(steps)
  },[steps])

  useEffect(() => {
    if (
      steps &&
      steps.find((s) => s?.step_number === current) &&
      steps.find((s) => s?.step_number === current).form_id &&
      steps.find((s) => s?.step_number === current).id
    ) {
      dispatch(
        getFields({
          formId: steps.find((s) => s?.step_number === current).form_id,
          stepId: steps.find((s) => s?.step_number === current).id,
        })
      ).then((res) => {
        const localFields = res?.payload &&
          Array.isArray(res?.payload) && [...res?.payload];
        setSortedFields(
          localFields?.sort((a, b) => a?.field_sequence - b?.field_sequence)
        );
      });
    }
  }, [steps]);

  useEffect(() => {
    if (
      coverPlans &&
      coverPlans.length > 0 &&
      existingSelectedPlan &&
      existingSelectedPlan !== undefined
    ) {
      // Keep this logic the same
    } else if (coverPlans && coverPlans.length > 0) {
      const arr = new Array(coverPlans.length).fill(false);
      arr[0] = true;
      setSelectedBenefit(arr);
      localStorage.setItem("selectedPlanId", coverPlans[0]?.coverage_plan?.plan_id);
    }
  }, [coverPlans]);

  const applyPolicy = () => {
    form1
      .validateFields()
      .then(() => {
        const values = form1.getFieldsValue();
        if (
          !form1.isFieldsTouched() &&
          existingValues &&
          JSON.parse(existingValues).find(
            (step) =>
              step.step_id === steps.find((s) => s?.step_number === current)?.id
          )
        ) {
          setCurrent(2);
        } else if (
          existingValues &&
          JSON.parse(existingValues).find(
            (step) =>
              step.step_id === steps.find((s) => s?.step_number === current)?.id
          )
        ) {
          dispatch(
            updateStep({
              userId: JSON.parse(sessionStorage.getItem("user"))?.userId,
              stepId: steps.find((s) => s?.step_number === current)?.id,
              parameters: fields?.map((field, i) => {
                return {
                  field_id: field?.id,
                  key: field?.field_name,
                  value: values[field?.field_name],
                };
              }),
            })
          );
          localStorage.removeItem("lastStep");
        } else {
          dispatch(
            saveStep({
              source: steps.find((s) => s?.step_number === current)
                ?.step_source,
              user_id: JSON.parse(sessionStorage.getItem("user"))?.userId,
              step_id: steps.find((s) => s?.step_number === current)?.id,
              parameters: fields?.map((field, i) => {
                return {
                  field_id: field?.id,
                  key: field?.field_name,
                  value: values[field?.field_name],
                };
              }),
            })
          );
        }
        localStorage.setItem(
          "selectedPlan",
          JSON.stringify(coverPlans[selectedBenefit.indexOf(true)])
        );
      })
      .then(() => {
        dispatch(clearSteps());
        navigate("/quotation");
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (
      existingValues &&
      JSON.parse(existingValues).find(
        (step) =>
          step.step_id === steps.find((s) => s?.step_number === current)?.id
      )
    ) {
      const values = JSON.parse(existingValues).find(
        (step) =>
          step.step_id === steps.find((s) => s?.step_number === current)?.id
      ).parameters;

      const obj = new Object();
      for (let key of values) {
        obj[key.key] = key.value;
      }
      form1.setFieldsValue(obj);
    }
  }, [steps]);

  useEffect(() => {
    if (
      getQoute &&
      existingValues &&
      form1.getFieldsValue() &&
      Object.keys(form1.getFieldsValue()).length > 0
    ) {
      const values = form1.getFieldsValue();
      const findScope =
        sessionStorage.getItem("values") &&
        JSON.parse(sessionStorage.getItem("values")).find(
          (step) => step.source === "cover_scope"
        )?.parameters;
      const parameters = {};
      const userId = sessionStorage.getItem("user") && JSON.parse(sessionStorage.getItem("user")).userId;
      parameters["user_id"] = userId;
      if (values["outpatient_copay"]) {
        parameters["co_payment"] = values["outpatient_copay"];
      }
      if (
        values["payment_frequency"] &&
        localStorage.getItem("coverageCountry") === "Kenya"
      ) {
        parameters["payment_options"] = values["payment_frequency"];
      }
      if (
        values["cover_period"] &&
        localStorage.getItem("coverageCountry") === "Kenya"
      ) {
        parameters["cover_period"] = values["cover_period"];
      }
      if (
        values["preferred_msp_list"] &&
        localStorage.getItem("coverageCountry") === "Kenya"
      ) {
        parameters["preferred_msp_list"] = values["preferred_msp_list"];
      }
      if (
        values["covertype"] &&
        localStorage.getItem("coverageCountry") === "Kenya"
      ) {
        parameters["type_of_cover"] = values["covertype"];
      }
      if (localStorage.getItem("coverageCountry") === "Kenya") {
        parameters["outpatient_care"] = outPatientCare;
        parameters["dental_care"] = dentalCare;
        parameters["optical_care"] = opticalCare;
      }

      if (findScope.find((par) => par.key === "principal_dob")) {
        parameters["age_of_principal"] = moment().diff(
          moment(
            findScope.find((par) => par.key === "principal_dob").value,
            "YYYY-MM-DD"
          ),
          "years"
        );
      }
      if (findScope.find((par) => par.key === "principal_spouse_age")) {
        parameters["age_of_spouse"] = moment().diff(
          moment(
            findScope.find((par) => par.key === "principal_spouse_age").value,
            "YYYY-MM-DD"
          ),
          "years"
        );
      }
      if (findScope.find((par) => par.key === "principal_children_count")) {
        parameters["number_of_children"] = findScope.find(
          (par) => par.key === "principal_children_count"
        ).value;
      }

      dispatch(getCoverPlans({ parameters, api })).then((res) => {
        if (res?.payload?.result?.length > 0) {
          let localPlans = res?.payload?.result;
          setCoverPlans(localPlans);
        } else {
          api.error({
            message: "Internal Server Error",
          });
        }
      });
    }
  }, [outPatientCare, dentalCare, opticalCare]);

  const handleGetEstimate = () => {
    form1
      .validateFields()
      .then(() => {
        const values = form1.getFieldsValue();
        console.log(values);
        const findScope =
          sessionStorage.getItem("values") &&
          JSON.parse(sessionStorage.getItem("values")).find(
            (step) => step.source === "cover_scope"
          )?.parameters;
        const parameters = {};
        const userId = sessionStorage.getItem("user") && JSON.parse(sessionStorage.getItem("user")).userId;
        parameters["user_id"] = userId;
        if (values.outpatient_copay) {
          parameters["co_payment"] = values.outpatient_copay;
        }
        if (
          values.payment_frequency &&
          localStorage.getItem("coverageCountry") === "Kenya"
        ) {
          parameters["payment_options"] = values.payment_frequency;
        }
        if (
          values.cover_period &&
          localStorage.getItem("coverageCountry") === "Kenya"
        ) {
          parameters["cover_period"] = values.cover_period;
        }
        if (
          values.preferred_msp_list &&
          localStorage.getItem("coverageCountry") === "Kenya"
        ) {
          parameters["preferred_msp_list"] = values.preferred_msp_list;
        }
        if (
          values.covertype &&
          localStorage.getItem("coverageCountry") === "Kenya"
        ) {
          parameters["type_of_cover"] = values.covertype;
        }
        if (localStorage.getItem("coverageCountry") === "Kenya") {
          parameters["outpatient_care"] = outPatientCare;
          parameters["dental_care"] = dentalCare;
          parameters["optical_care"] = opticalCare;
        }
        if (findScope?.find((par) => par.key === "principal_dob")) {
          parameters["age_of_principal"] = moment().diff(
            moment(
              findScope.find((par) => par.key === "principal_dob").value,
              "YYYY-MM-DD"
            ),
            "years"
          );
        }
        if (findScope?.find((par) => par.key === "principal_spouse_age")) {
          parameters["age_of_spouse"] = moment().diff(
            moment(
              findScope.find((par) => par.key === "principal_spouse_age").value,
              "YYYY-MM-DD"
            ),
            "years"
          );
        }
        if (findScope?.find((par) => par.key === "principal_children_count")) {
          parameters["number_of_children"] = findScope.find(
            (par) => par.key === "principal_children_count"
          ).value;
        }

        dispatch(getCoverPlans({ parameters, api })).then((res) => {
          if (res?.payload?.result?.length > 0) {
            let localPlans = res?.payload?.result;
            setCoverPlans(localPlans);
          } else {
            console.log("");
          }
        });
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <div className={styles.stepWrapper}>
        {/* Cover Details Card */}
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <div className={styles.cardHeaderLeft}>
              <div className={styles.cardIcon}>
                <Calculator size={20} />
              </div>
              <div>
                <Title level={4} className={styles.cardTitle}>Policy Cover Details</Title>
                <Text className={styles.cardDesc}>Configure your coverage preferences</Text>
              </div>
            </div>
            <button
              onClick={() => setCollapsed((prev) => !prev)}
              className={styles.collapseBtn}
            >
              {!collapsed ? "Collapse" : "Expand"}
            </button>
          </div>

          <div className={styles.cardBody}>
            <Form className={styles.formContainer} layout="vertical" form={form1}>
              {!collapsed && (
                <div className={styles.coverGrid}>
                  {sortedFields &&
                    sortedFields.length > 0 &&
                    sortedFields.map((field, index) => {
                      return (
                        <Form.Item
                          rules={validationRules(field?.validation, field?.label)}
                          name={field?.field_name}
                          label={
                            field?.label === "Outpatient Co-Pay" ||
                            field?.label === "Cover Type" ||
                            field?.label === "Service Provider Category" ? (
                              <span className={styles.fieldLabel}>
                                {field?.label}
                                <Tooltip
                                  title={
                                    field?.label === "Outpatient Co-Pay" ? (
                                      tooltipContent.copay
                                    ) : field?.label === "Cover Type" ? (
                                      tooltipContent.coverType
                                    ) : (
                                      <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                                        {tooltipContent.serviceProviderCategory}
                                        <div
                                          style={{ textDecoration: "underline", cursor: 'pointer' }}
                                          onClick={() => window.open('https://docs.google.com/spreadsheets/d/e/2PACX-1vToC3iNwLng-Ys02tVmzTiV2i-6yFg-EzzdLJm3u9ysZLaXmQ3ISQESYuUBb-fRjBJgS68vr658-9cd/pubhtml', '_blank')}
                                        >
                                          Provider list
                                        </div>
                                      </div>
                                    )
                                  }
                                >
                                  <HelpCircle size={14} color="#94a3b8" style={{ cursor: 'help' }} />
                                </Tooltip>
                              </span>
                            ) : (
                              <span className={styles.fieldLabel}>{field?.label}</span>
                            )
                          }
                          key={index}
                        >
                          {field?.type === "dropdown" && (
                            <Select
                              allowClear
                              onChange={() => dispatch(disableQoute())}
                              className={styles.fieldSelect}
                              options={field?.dropdowns
                                ?.filter((r) =>
                                  r?.regions?.find((r) => r === coverageCountry)
                                )?.[0]
                                ?.values?.map((opt) => {
                                  return { label: opt?.name, value: opt?.value };
                                })}
                              placeholder={field?.label}
                              showSearch
                              optionFilterProp="label"
                            />
                          )}
                          {field?.type === "date" && (
                            <DatePicker
                              allowClear
                              className={styles.fieldDatePicker}
                              format={"YYYY-MM-DD"}
                            />
                          )}
                        </Form.Item>
                      );
                    })}
                </div>
              )}

              {!collapsed && <div className={styles.sectionDivider} />}

              {!getQoute && (
                <div className={styles.estimateActions}>
                  <Button
                    className={styles.getEstimateBtn}
                    size="large"
                    onClick={handleGetEstimate}
                  >
                    <Sparkles size={16} />
                    Get Your Estimate
                  </Button>
                  <button
                    onClick={() => setCurrent(2)}
                    className={styles.editLink}
                  >
                    <Pencil size={13} />
                    Edit Dependents
                  </button>
                </div>
              )}
            </Form>
          </div>
        </div>

        {/* Empty State */}
        {!getQoute && (
          <div className={styles.emptyState}>
            <img src={peopleWorking} alt="People working" className={styles.emptyImg} />
            <Text className={styles.emptyText}>
              Your available cover plans will appear here once the estimate is calculated.
            </Text>
          </div>
        )}

        {/* Cover Benefits */}
        {getQoute && coverPlans && coverPlans.length > 0 && (
          <div className={styles.card} style={{ marginTop: 20 }}>
            <div className={styles.cardHeader}>
              <div className={styles.cardHeaderLeft}>
                <div className={styles.cardIcon}>
                  <FileText size={20} />
                </div>
                <div>
                  <Title level={4} className={styles.cardTitle}>Cover Benefits</Title>
                  <Text className={styles.cardDesc}>Select a plan that fits your needs</Text>
                </div>
              </div>
              <Tooltip title={tooltipContent.coverBenefits}>
                <HelpCircle size={18} color="#94a3b8" style={{ cursor: 'help' }} />
              </Tooltip>
            </div>

            <div className={styles.cardBody}>
              <div className={styles.plansGrid}>
                {coverPlans.map((benefits, index) => (
                  <EnhancedCoverBenefits
                    key={benefits?.plan_id}
                    checked={selectedBenefit[index]}
                    planName={benefits?.coverage_plan?.plan_name}
                    region={
                      benefits?.coverage_plan?.options?.find(
                        (ben) => ben?.name === "Georgraphical Coverage"
                      )?.value
                    }
                    onChange={(e) => {
                      let arr = new Array(coverPlans.length).fill(false);
                      arr[index] = true;
                      setSelectedBenefit(arr);
                      localStorage.setItem("selectedPlanId", benefits?.coverage_plan?.plan_id);
                    }}
                    totalValue={benefits?.estimated_price?.estimated_price}
                    coverBenefits={benefits?.coverage_plan?.options?.map(
                      (ben) => {
                        return { benefit: ben?.name, value: ben?.value };
                      }
                    )}
                    outPatientCare={outPatientCare}
                    dentalCare={dentalCare}
                    opticalCare={opticalCare}
                    onRadioChange={(service) => {
                      if (service === "Outpatient Care") {
                        dispatch(setOutPatientCare());
                      } else if (service === "Dental Care Coverage") {
                        dispatch(setDentalCare());
                      } else {
                        dispatch(setOpticalCare());
                      }
                    }}
                    coverPlansLoading={coverPlansLoading}
                  />
                ))}
                {loading && (
                  <div className={styles.loadingState}>
                    <Loader2 size={28} color="#028D86" className={styles.spinner} />
                    <span>Loading plans...</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Bottom Actions */}
        <div className={styles.actions}>
          <Button
            onClick={() => setCurrent((curr) => curr - 1)}
            className={styles.backBtn}
            size="large"
          >
            <ArrowLeft size={16} />
            Back
          </Button>
          <Button
            type="primary"
            onClick={applyPolicy}
            disabled={selectedBenefit.every((b) => !b) || !getQoute}
            className={styles.applyBtn}
            size="large"
          >
            Apply Now
          </Button>
        </div>
      </div>
      {context}
    </>
  );
}

const EnhancedCoverBenefits = ({
  planName,
  totalValue,
  region,
  coverBenefits,
  checked,
  onChange,
  outPatientCare,
  dentalCare,
  onRadioChange,
  opticalCare,
  coverPlansLoading,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const items =
    coverBenefits.length > 0
      ? coverBenefits.map((ben, i) => {
          return { key: `${i}`, label: ben?.name };
        })
      : [];

  const validBenefits = [
    "Inpatient Care",
    "Outpatient Care",
    "Dental Care Coverage",
    "Optical Care Coverage",
  ];

  const getBenefitIcon = (benefitName) => {
    if (benefitName === "Inpatient Care") return <Stethoscope size={15} color="#028D86" />;
    if (benefitName === "Outpatient Care") return <User size={15} color="#028D86" />;
    if (benefitName === "Dental Care Coverage") return <Stethoscope size={15} color="#028D86" />;
    if (benefitName === "Optical Care Coverage") return <Eye size={15} color="#028D86" />;
    return <Check size={15} color="#028D86" />;
  };

  const currency = localStorage.getItem("coverageCountry") === "Kenya" ? "KES" : "RWF";

  return (
    <div
      className={`${styles.planCard} ${checked ? styles.planCardSelected : ""}`}
      onClick={onChange}
    >
      <div className={styles.planHeader}>
        <Radio checked={checked} onChange={onChange} />
        <div className={styles.planInfo}>
          {coverPlansLoading ? (
            <Loader2 size={18} className={styles.spinner} />
          ) : (
            <div className={styles.planPrice}>
              {`${currency} ${totalValue ? totalValue.toLocaleString("US") : ""}`}
            </div>
          )}
          <div className={styles.planName}>{planName}</div>
        </div>
      </div>

      <div className={styles.planDivider} />

      <button
        className={styles.viewCoverLink}
        onClick={(e) => {
          e.stopPropagation();
          window.open(viewCover, '_blank');
        }}
      >
        <ExternalLink size={13} />
        Full Cover Details
      </button>

      <div className={styles.benefitsList}>
        {coverBenefits
          .filter((ben) => {
            if (!isNaN(parseInt(ben.value))) {
              if (
                localStorage.getItem("coverageCountry") === "Kenya" &&
                validBenefits.indexOf(ben.benefit) !== -1
              ) {
                return true;
              } else if (
                localStorage.getItem("coverageCountry") !== "Kenya"
              ) {
                return true;
              } else {
                return false;
              }
            }
          })
          .map((benefit, index) => {
            return (
              <div key={index} className={styles.benefitRow}>
                <div className={styles.benefitName}>
                  {localStorage.getItem("coverageCountry") === "Kenya" &&
                  (benefit.benefit === "Outpatient Care" ||
                    benefit.benefit === "Dental Care Coverage" ||
                    benefit.benefit === "Optical Care Coverage") ? (
                    <Checkbox
                      onClick={(e) => {
                        e.stopPropagation();
                        onRadioChange(
                          benefit.benefit === "Outpatient Care"
                            ? "Outpatient Care"
                            : benefit.benefit === "Dental Care Coverage"
                            ? "Dental Care Coverage"
                            : "Optical Care Coverage"
                        );
                      }}
                      checked={
                        benefit.benefit === "Outpatient Care"
                          ? outPatientCare
                          : benefit.benefit === "Dental Care Coverage"
                          ? dentalCare
                          : opticalCare
                      }
                    />
                  ) : (
                    <Checkbox checked />
                  )}
                  <span className={styles.benefitIcon}>{getBenefitIcon(benefit.benefit)}</span>
                  <span>{benefit.benefit}</span>
                </div>
                <div className={styles.benefitValue}>
                  {`${currency} ${
                    benefit?.value &&
                    parseInt(benefit?.value?.replace(/,/g, ""))?.toLocaleString("US")
                  }`}
                </div>
              </div>
            );
          })}
      </div>
      <Modal
        footer={false}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
      >
        <Descriptions title={planName} items={items} />
      </Modal>
    </div>
  );
};

export default EnhancedStep3;
